"use client";
import React, { useContext } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Typography } from "@/components/Typography";
import { featuredProps } from "@/data/types/home";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";
import { paths } from "@/utils/paths";

import { Banner } from "../Banner";

import "./styles.scss";

// Fix Warning: Prop 'className' did not match. Import component by turning off ssr
const Featured = dynamic(() => import("@/components/Featured").then((mod) => mod.Featured), {
  ssr: false,
});

export const ThreeStepsModule = ({ data }: { data: featuredProps }) => {
  const router = useRouter();
  const { List, Title, Subtitle, ctaLabel, data_qa, customClass } = data;
  const { setSource } = useContext(AmplitudeContext);

  const handleStepsClick = () => {
    setSource("cta_steps");
    router.push(paths.qrEditor());
  };

  return (
    <Banner
      light
      withoutPadding
      customBgColor={"neutral-50"}
      data-testid="three-steps-module"
    >
      <div className="three-steps-module">
        <Typography
          Tag={"h2"}
          spacing={8}
        >
          {Title}
        </Typography>
        <Typography
          Tag={"p"}
          spacing={8}
        >
          {Subtitle}
        </Typography>

        <Featured
          items={List}
          customClass={customClass}
        />
        <div className="buttonWrapper cta-steps-banner-btn">
          <ButtonLib
            dataQA={data_qa}
            onClick={handleStepsClick}
            label={ctaLabel}
            variant="secondary"
          />
        </div>
      </div>
    </Banner>
  );
};
